/**
 * These are the list of custom RUM actions that we track in datadog.
 */
export enum DatadogCustomAction {
    BLEND_AUTH_START = 'homeloansdashboard.dashboard.auth.blend-auth-start',
    BLEND_AUTH_ERROR = 'homeloansdashboard.dashboard.auth.blend-auth-error',
    DASHBOARD_BOUNCE_PAGE_LOADED = 'dashboard.bounce-page',
    DASHBOARD_ACTIVATE_PAGE_SUCCESS = 'dashboard.activate-page-success',
    DASHBOARD_ACTIVATE_PAGE_FAILURE = 'dashboard.activate-page-failure',
    DASHBOARD_PAGE_LOADED = 'dashboard.dashboard-page',
    DASHBOARD_BOUNCE_TO_GOLDENEYE = 'dashboard.bounce-to-goldeneye',
    DASHBOARD_BOUNCE_TO_BLEND = 'dashboard.bounce-to-blend',
    DASHBOARD_BOUNCE_TO_DASHBOARD = 'dashboard.bounce-to-dashboard',
    DASHBOARD_START_BLEND_ERROR = 'dashboard.start-blend-error',
    DASHBOARD_START_BLEND_SUCCESS = 'dashboard.start-blend-success',
    DASHBOARD_START_DIGITAL_PREAPPROVAL_SUCCESS = 'dashboard.start-digital-preapproval-success',
    DASHBOARD_START_DIGITAL_PREAPPROVAL_ERROR = 'dashboard.start-digital-preapproval-error',
    DASHBOARD_BLEND_CTA_CLICK = 'dashboard.blend-cta-click',
    MIGRATION_REDIRECT = 'dashboard.migration-redirect',
    AUTHENTICATION_START = 'homeloansdashboard.dashboard.auth.session-start',
    CLICKSTREAM_EVENT = 'dashboard.clickstream-event',
    CALLBACK_SCHEDULER_START = 'homeloansdashboard.callback-scheduler.session-start',
    CALLBACK_SCHEDULER_TIME_SLOT_NOT_AVAILABLE = 'homeloansdashboard.callback-scheduler.time-slot-not-available',
    CALLBACK_SCHEDULER_SUCCESS_IMPRESSION = 'homeloansdashboard.callback-scheduler.success-impression',
    CALLBACK_SCHEDULER_FAILURE_IMPRESSION = 'homeloansdashboard.callback-scheduler.failure-impression',
    CALLBACK_SCHEDULER_CANCEL_CTA_CLICK = 'homeloansdashboard.callback-scheduler.cancel-cta-click',
    CALLBACK_SCHEDULER_BOOK_APPOINTMENT_CLICK = 'homeloansdashboard.callback-scheduler.book-appointment-click',
    CALLBACK_SCHEDULER_FATAL_ERROR = 'homeloansdashboard.callback-scheduler.fatal-error',
    CALLBACK_SCHEDULER_GRAPH_ERROR = 'homeloansdashboard.callback-scheduler.non-fatal-error',
    CALLBACK_SCHEDULER_NEXT_STEP_CTA_CLICK = 'homeloansdashboard.callback-scheduler.next-step-cta-click',
    CALLBACK_SCHEDULER_EMPTY_SLOTS_ERROR = 'homeloansdashboard.callback-scheduler.empty-slots-error',
}
